// extracted by mini-css-extract-plugin
module.exports = {"img":"DishImageLarge_img__4m0j4"};